// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import Fetch from '@/utils/Fetch';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import ManageInvoiceForm from "@/PageComponents/Invoice/ManageInvoiceForm";
import { createFileRoute } from '@tanstack/react-router'

function EditInvoice() {
  const router = useRouter();
  const { id, tab, module, moduleID, customerID } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [initTab, setInitTab] = useState<any>(null);

  const { data: invoice } = useQuery(
    ['invoice', id],
    () => Fetch.get({ url: `/Invoice/${id}` }),
    { enabled: !!id }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    if (initTab === null && router.isReady) {
      setInitTab(tab === 'communication' ? 'Messages' : 'Invoice');
    }
  }, [router.isReady, tab]);

  if (!invoice || !company || initTab === null) return null;

  return (
    <>
      <Head><title>{invoice?.InvoiceNumber} | Invoices</title></Head>
      <div>
        <ManageInvoiceForm
          mode={'page'}
          isNew={false}
          initTab={initTab}
          module={module ? +module : undefined}
          moduleID={moduleID}
          company={company}
          customerID={customerID}
          invoice={invoice}
          invoiceItems={invoice.InvoiceItems}
          accessStatus={accessStatus}
          useTabs
        />
      </div>
    </>
  );
}

export default EditInvoice;

export const Route = createFileRoute('/_authenticated/invoice/$id')({ component: EditInvoice })
